import { Checkbox as Check } from "antd";
import React, { useState } from "react";

const Checkbox = ({
  description,
  fontColor,
  link,
  onChecked,
  name,
  initialValue,
}) => {
  const [isChecked1, setIsChecked1] = useState(initialValue || false);

  const onChange1 = (e) => {
    setIsChecked1(!isChecked1);
    if (name) onChecked(name, e.target.checked);
    else onChecked(e.target.checked);
  };

  const checkboxStyle = {
    "--checkbox-inner-color": isChecked1 ? "#4A83FD" : "#f0f0f0",
  };

  return (
    <div className="flex items-start ">
      <Check checked={isChecked1} onChange={onChange1} style={checkboxStyle} />
      <p
        style={{ marginLeft: "8px", display: "block" }}
        className={fontColor ? fontColor : "pstyle  font-medium"}
      >
        {description}
        {link}
      </p>
      <style>{`
    .ant-checkbox-checked .ant-checkbox-inner,
    .ant-checkbox-inner:not(.ant-checkbox-checked) {
      background-color: var(--checkbox-inner-color) !important;
      border-color: var(--checkbox-inner-color) !important;
    }
  `}</style>
    </div>
  );
};

export default Checkbox;
